export const authRoles = {
  level1: ['ADMIN'],
  level2: ['ADMIN', 'MANAGER'], 
  level3: ['ADMIN', 'MANAGER', 'EXECUTIVE'] 
}
